// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listItem_WJcxx {
  cursor: pointer;
}

.footer_kozu4 {
  padding: 5px 0;
  margin-top: auto;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/list/MobileListView.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".listItem {\n  cursor: pointer;\n}\n\n.footer {\n  padding: 5px 0;\n  margin-top: auto;\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItem": `listItem_WJcxx`,
	"footer": `footer_kozu4`
};
export default ___CSS_LOADER_EXPORT___;
